module.exports = __webpack_public_path__ + "static/griddle.0e4f9455.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/griddle.jpg
// module id = 846
// module chunks = 73261030922168